function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M7.875 16.972L12 21.25m0 0l4.125-4.278M12 21.25v-9.625M20.877 17.125a5.017 5.017 0 00.076-8.138A4.99 4.99 0 0018 8.021h-1.26a8.019 8.019 0 00-4.513-5.338A7.98 7.98 0 002.54 5.285a8.021 8.021 0 00.468 10.037",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _ref);
}

export default SvgDownload;